import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {
  Container,
  Row,
  Col
} from 'reactstrap';
import styles from './styles.scss';


const propTypes = {
  radon: PropTypes.string,
  temperature: PropTypes.string,
  humidity: PropTypes.string,
  pressure: PropTypes.string,
  active: PropTypes.bool
};

const UomBlock = ({ radon, temperature, humidity, pressure, active }) => (
  <Container className={classNames(styles.container, {
    [styles.inactive]: !active
  })}>
    <Row>
      <Col>
        <label className='font-weight-bold'>Radon</label>
      </Col>
      <Col>
        <label>{radon}</label>
      </Col>
    </Row>
    <Row>
      <Col>
        <label className='font-weight-bold'>Temperature</label>
      </Col>
      <Col>
        <label>{temperature}</label>
      </Col>
    </Row>
    <Row>
      <Col>
        <label className='font-weight-bold'>Humidity</label>
      </Col>
      <Col>
        <label>{humidity}</label>
      </Col>
    </Row>
    <Row>
      <Col>
        <label className='font-weight-bold'>Pressure</label>
      </Col>
      <Col>
        <label>{pressure}</label>
      </Col>
    </Row>
  </Container>
);

UomBlock.propTypes = propTypes;

export default UomBlock;


// WEBPACK FOOTER //
// src/components/shared/UomBlock/index.jsx